import { __assign } from "tslib";
import { ApiTypes, } from '../sdk.types';
import { flattenMarks } from './flattenMarks';
var concatHighlights = function (input, highlights) { return (highlights ? flattenMarks(highlights === null || highlights === void 0 ? void 0 : highlights.join(' ')) : input); };
var markHighlights = function (input, highlights) {
    if (!highlights) {
        return input;
    }
    var withMarks = highlights.join().match(/<mark>(.*?)<\/mark>/g) || [];
    var withoutMarks = withMarks.map(function (match) { return match.replace(/<[^>]*>/gi, ''); });
    var result = input;
    withoutMarks.forEach(function (highlight) {
        result = result.replace(highlight, "<mark>" + highlight + "</mark>");
    });
    return flattenMarks(result);
};
var DocumentParser = /** @class */ (function () {
    function DocumentParser(siteBaseUrl) {
        this.siteBaseUrl = siteBaseUrl;
    }
    DocumentParser.prototype.parseDefaultDocument = function (rawDocument) {
        var _a, _b;
        return {
            description: concatHighlights(rawDocument.description, (_a = rawDocument._highlights) === null || _a === void 0 ? void 0 : _a.description),
            image: rawDocument.documentImage,
            relativeUrl: rawDocument.url,
            title: markHighlights(rawDocument.title, (_b = rawDocument._highlights) === null || _b === void 0 ? void 0 : _b.title),
            url: "" + this.siteBaseUrl + rawDocument.url,
        };
    };
    DocumentParser.prototype.parse = function (rawDocument) {
        var _a;
        var documentType = rawDocument.documentType;
        switch (documentType) {
            case ApiTypes.SearchDocumentType.Products:
                return __assign(__assign({}, this.parseDefaultDocument(rawDocument)), { documentType: documentType, price: rawDocument.discountedPrice });
            case ApiTypes.SearchDocumentType.Pages:
                return __assign(__assign({}, this.parseDefaultDocument(rawDocument)), { documentType: documentType });
            case ApiTypes.SearchDocumentType.Blogs:
                return __assign(__assign({}, this.parseDefaultDocument(rawDocument)), { documentType: documentType });
            case ApiTypes.SearchDocumentType.Forums:
                return __assign(__assign({}, this.parseDefaultDocument(rawDocument)), { documentType: documentType });
            case ApiTypes.SearchDocumentType.Bookings:
                return __assign(__assign({}, this.parseDefaultDocument(rawDocument)), { documentType: documentType });
            case ApiTypes.SearchDocumentType.Events:
                return __assign(__assign({}, this.parseDefaultDocument(rawDocument)), { currency: rawDocument.currency, documentType: documentType, eventType: rawDocument.eventType, location: rawDocument.location &&
                        markHighlights(rawDocument.location, (_a = rawDocument._highlights) === null || _a === void 0 ? void 0 : _a.location), maxPrice: rawDocument.maxPrice, minPrice: rawDocument.minPrice, startDate: rawDocument.startDate });
            default:
                // typechecking if we forgot any SearchDocumentType.
                // in runtime, function will still work if we got an unknown document type from the backend
                var unknownDocumentType = documentType;
                console.warn("You're trying to parse unknown document type - " + rawDocument.documentType);
                return __assign(__assign({}, this.parseDefaultDocument(rawDocument)), { documentType: unknownDocumentType });
        }
    };
    return DocumentParser;
}());
export { DocumentParser };
//# sourceMappingURL=DocumentParser.js.map